import React, { useState, useEffect, useRef } from "react";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import { Link } from "react-router-dom";
import axios from "axios";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import backarrow from "../../../../components/Images/backarrow.svg";
import "./site_setting.css";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import Select from "react-select";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import { toast } from "react-toastify";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
function Video_Setting(props) {
  // const [message, setMessage] = useState("");
  const { fetchRequest } = useMyContext()
  const [setting, setSetting] = useState({
    // Advertisement_Setting
    ads_on_videos: "",
    cpc_advertiser: "",
    featured_pre_ad: "",
    featured_mid_ad: "",
    featured_post_ad: "",
    cpc_admin: "",
    cpv_advertiser: "",
    cpv_admin: "",
    default_ads_url: "",
    ads_play_unlimited_period: "",
    ads_on_livestream: "",
    ads_on_audios: "",
    ads_on_episodes: "",
    // Advertisement_Setting
    //coupon code
    new_subscriber_coupon: "",
    discount_percentage: "",
    coupon_code: "",
    //coupon code
    //email setting
    google_oauth_key: "",
    coupon_status: "",
    google_tracking_id: "",
    system_email: "",
    system_phone_number: "",
    system_address: "",
    //email setting
    //login setting
    notification_icon: "",
    notification_key: "",
    login_text: "",
    login_content: "",
    signature: "",
    //login setting
    //geo fencing
    id: "",
    geofencing: "",
    geofencing_status: "",
    //geo fencing
    // payout setting
    payout_method: "",
    //payout setting
    //ppv setting
    ppv_status: "",
    ppv_rent: "",
    ppv_price: "",
    ppv_hours: "",
    ios_product_id: "",
    ios_plan_price: "",
    expiry_time_started: "",
    expiry_day_notstarted: "",
    expiry_hours_notstarted: "",
    expiry_min_notstarted: "",
    PPV_Individual_Contents: "",
    enable_ppv_rent_live: "",
    enable_ppv_rent_series: "",
    enable_ppv_rent_audio: "",
    google_analytics_link: "",
    //ppv setting
    // capcha setting
    captcha_site_key: "",
    captcha_secret_key: "",
    captcha: "",
    //capcha setting
    //registration settings
    free_registration: "",
    activation_email: "",
    premium_upgrade: "",
    access_free: "",
    enable_landing_page: "",
    //registration settings
    //search settings
    search_title_status: "",
    search_category_status: "",
    search_tags_status: "",
    search_description_status: "",
    search_details_status: "",
    //search settings
    //series settings
    series_season: "",
    series_networks_status: "",
    //series settings
    //site settings
    website_name: "",
    website_description: "",
    logo_height: "",
    logo_width: "",
    login_content: "",
    favicon: "",
    logo: "",
    //site settings
    //social network settings
    facebook_page_id: "",
    google_page_id: "",
    twitter_page_id: "",
    instagram_page_id: "",
    linkedin_page_id: "",
    whatsapp_page_id: "",
    skype_page_id: "",
    youtube_page_id: "",
    email_page_id: "",
    tiktok_page_id: "",
    //social network settings
    //video settings
    videos_per_page: "",
    posts_per_page: "",
    show_description: "",
    show_Links_and_details: "",
    show_genre: "",
    show_languages: "",
    show_subtitle: "",
    show_artist: "",
    show_recommended_videos: "",
    show_views: "",
    videos_expiry_status: "",
    epg_status: "",
    //video settings
    earn_amount: "",
    video_clip_enable: "",
    enable_ppv_rent: "",
    homepage_views_all_button_status: "",
    filter_status: "", // New field for multiple select filter options
    registered_device_restriction: "",
    nonsubscribers_resolutions: "",
    new_release_enable: "",
    new_release_days: "",
  });

  // const navigate = useNavigate();
  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  useEffect(async () => {
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/setting/index`, {
        headers: headers,
      })
      .then((response) => {
        var setting = response?.data?.setting;
        setSetting(setting);
        // console.log(setting);
      })
      .catch((error) => console.log(error));
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (e.target.type === "number" && Number(value) < 0) return;

    setSetting((prevSetting) => ({
      ...prevSetting,
      [name]: value,
    }));

    setValidationMessagevideos_per_page("");
    setIsValidationHiddenvideos_per_page(true);
  };

  const handleInputenable = (e) => {
    if (e.target.checked === true) {
      setSetting({ ...setting, [e.target.name]: 1 });
    } else {
      setSetting({ ...setting, [e.target.name]: 0 });
    }
  };

  const [
    validationMessagevideos_per_page,
    setValidationMessagevideos_per_page,
  ] = useState("");
  const [
    isValidationHiddenvideos_per_page,
    setIsValidationHiddenvideos_per_page,
  ] = useState(true);

  const videos_per_pageInputRef = useRef(null);

  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  // Filter status options
  const filterStatusOptions = [
    { value: '1', label: 'Artist' },
    { value: '2', label: 'Language' },
    { value: '3', label: 'Category' },
    { value: '4', label: 'Genre' },
  ];

  const registrationResolutions = [
    { value: 144, label: '144p' },
    { value: 240, label: '240p' },
    { value: 360, label: '360p' },
    { value: 480, label: '480p' },
    { value: 720, label: '720p' },
    { value: 1080, label: '1080p' },
    { value: 1440, label: '1440p' },
    { value: 2160, label: '2160p' },
    { value: 4320, label: '4320p' },
  ];

  // Convert filter_status string to react-select format
  const getFilterStatusValue = () => {
    if (!setting?.filter_status) return [];
    const selectedValues = setting.filter_status.split(',').filter(val => val.trim() !== '');
    return filterStatusOptions.filter(option => selectedValues.includes(option.value));
  };

  // const getresolutionValue = () => {
  //   const stored = setting?.nonsubscribers_resolutions;
  //   if (!Array.isArray(stored)) return [];
  //   const storedAsStrings = stored.map(String);
  //   return registrationResolutions.filter(opt =>
  //     storedAsStrings.includes(opt.value)
  //   );
  // };


  const resolvedValues = React.useMemo(() => {
    const stored = setting?.nonsubscribers_resolutions;
    console.log("STORED:", stored);

    if (!Array.isArray(stored)) return [];

    return registrationResolutions.filter(opt =>
      stored.includes(opt.value)
    );
  }, [setting]);

  // Handler for filter status multi-select
  const handleFilterStatusChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setSetting(prevSetting => ({
      ...prevSetting,
      filter_status: selectedValues.join(',')
    }));
  };

  const handleregistrationResolutionsChange = (selectedOptions) => {
    const arr = selectedOptions ? selectedOptions.map(o => o.value) : [];
    setSetting(prev => ({ ...prev, nonsubscribers_resolutions: arr }));
  };


  const handleUpdate = async (e) => {
    e.preventDefault();

    let focusInputRef = null;
    let hasValidationError = false;

    if (setting?.videos_per_page === "") {
      setValidationMessagevideos_per_page("Videos Per Page cannot be empty.");
      setIsValidationHiddenvideos_per_page(false);
      focusInputRef = videos_per_pageInputRef;
      hasValidationError = true;
    }

    if (hasValidationError) {
      if (focusInputRef && focusInputRef.current) {
        try {
          focusInputRef.current.focus();
        } catch (error) {
          console.warn('Could not focus input field:', error);
        }
      }
      return;
    }


    const enable_ppv_rent = Number.isNaN(parseInt(setting?.enable_ppv_rent, 10)) ? 0 : parseInt(setting?.enable_ppv_rent, 10);

    // advertisement setting
    const ads_on_videos = Number.isNaN(parseInt(setting?.ads_on_videos, 10)) ? 0 : parseInt(setting?.ads_on_videos, 10);
    const ads_play_unlimited_period = Number.isNaN(parseInt(setting?.ads_play_unlimited_period, 10)) ? 0 : parseInt(setting?.ads_play_unlimited_period, 10);
    const ads_on_livestream = Number.isNaN(parseInt(setting?.ads_on_livestream, 10)) ? 0 : parseInt(setting?.ads_on_livestream, 10);
    const ads_on_audios = Number.isNaN(parseInt(setting?.ads_on_audios, 10)) ? 0 : parseInt(setting?.ads_on_audios, 10);
    const ads_on_episodes = Number.isNaN(parseInt(setting?.ads_on_episodes, 10)) ? 0 : parseInt(setting?.ads_on_episodes, 10);

    //coupon setting      
    const coupon_code = Number.isNaN(parseInt(setting?.coupon_code, 10)) ? 0 : parseInt(setting?.coupon_code, 10);


    //payout settings   
    const payout_method = Number.isNaN(parseInt(setting?.payout_method, 10)) ? 0 : parseInt(setting?.payout_method, 10);


    //registration settings
    const free_registration = Number.isNaN(parseInt(setting?.free_registration, 10)) ? 0 : parseInt(setting?.free_registration, 10);


    //search settings
    const search_title_status = Number.isNaN(parseInt(setting?.search_title_status, 10)) ? 0 : parseInt(setting?.search_title_status, 10);
    const search_category_status = Number.isNaN(parseInt(setting?.search_category_status, 10)) ? 0 : parseInt(setting?.search_category_status, 10);
    const search_tags_status = Number.isNaN(parseInt(setting?.search_tags_status, 10)) ? 0 : parseInt(setting?.search_tags_status, 10);
    const search_description_status = Number.isNaN(parseInt(setting?.search_description_status, 10)) ? 0 : parseInt(setting?.search_description_status, 10);
    const search_details_status = Number.isNaN(parseInt(setting?.search_details_status, 10)) ? 0 : parseInt(setting?.search_details_status, 10);


    //serires settings
    const series_networks_status = Number.isNaN(parseInt(setting?.series_networks_status, 10)) ? 0 : parseInt(setting?.series_networks_status, 10);

    // video settings 
    const videos_expiry_status = Number.isNaN(parseInt(setting?.videos_expiry_status, 10)) ? 0 : parseInt(setting?.videos_expiry_status, 10);
    const videos_per_page = Number.isNaN(parseInt(setting?.videos_per_page, 10)) ? 0 : parseInt(setting?.videos_per_page, 10);
    const epg_status = Number.isNaN(parseInt(setting?.epg_status, 10)) ? 0 : parseInt(setting?.epg_status, 10);
    const show_genre = Number.isNaN(parseInt(setting?.show_genre, 10)) ? 0 : parseInt(setting?.show_genre, 10);
    const show_languages = Number.isNaN(parseInt(setting?.show_languages, 10)) ? 0 : parseInt(setting?.show_languages, 10);
    const show_subtitle = Number.isNaN(parseInt(setting?.show_subtitle, 10)) ? 0 : parseInt(setting?.show_subtitle, 10);
    const show_artist = Number.isNaN(parseInt(setting?.show_artist, 10)) ? 0 : parseInt(setting?.show_artist, 10);
    const show_recommended_videos = Number.isNaN(parseInt(setting?.show_recommended_videos, 10)) ? 0 : parseInt(setting?.show_recommended_videos, 10);
    const show_views = Number.isNaN(parseInt(setting?.show_views, 10)) ? 0 : parseInt(setting?.show_views, 10);
    const show_Links_and_details = Number.isNaN(parseInt(setting?.show_Links_and_details, 10)) ? 0 : parseInt(setting?.show_Links_and_details, 10);
    const show_description = Number.isNaN(parseInt(setting?.show_description, 10)) ? 0 : parseInt(setting?.show_description, 10);
    const homepage_views_all_button_status = Number.isNaN(parseInt(setting?.homepage_views_all_button_status, 10)) ? 0 : parseInt(setting?.homepage_views_all_button_status, 10);

    const editInputvalue = {

      // advertisement setting
      ads_on_videos: ads_on_videos,
      default_ads_url: setting?.default_ads_url,
      featured_pre_ad: setting?.featured_pre_ad,
      featured_mid_ad: setting?.featured_mid_ad,
      featured_post_ad: setting?.featured_post_ad,
      cpv_admin: setting?.cpv_admin,
      cpv_advertiser: setting?.cpv_advertiser,
      cpc_admin: setting?.cpc_admin,
      cpc_advertiser: setting?.cpc_advertiser,
      ads_play_unlimited_period: ads_play_unlimited_period,
      ads_on_livestream: ads_on_livestream,
      ads_on_audios: ads_on_audios,
      ads_on_episodes: ads_on_episodes,

      //coupon setting      
      discount_percentage: setting?.discount_percentage,
      coupon_code: coupon_code,
      new_subscriber_coupon: setting?.new_subscriber_coupon,

      //email settings
      coupon_status: setting?.coupon_status,
      google_tracking_id: setting?.google_tracking_id,
      google_oauth_key: setting?.google_oauth_key,
      system_email: setting?.system_email,
      system_phone_number: setting?.system_phone_number,

      //login settings      
      login_text: setting?.login_text,
      signature: setting?.signature,
      login_content: setting?.login_content,
      notification_key: setting?.notification_key,

      //payout setting
      payout_method: payout_method,

      //ppv settings
      ppv_status: setting?.ppv_status,
      PPV_Individual_Contents: setting?.PPV_Individual_Contents,
      ppv_price: setting?.ppv_price,
      ppv_hours: setting?.ppv_hours,
      ios_plan_price: setting?.ios_plan_price,
      ios_product_id: setting?.ios_product_id,
      expiry_time_started: setting?.expiry_time_started,
      expiry_day_notstarted: setting?.expiry_day_notstarted,
      expiry_hours_notstarted: setting?.expiry_hours_notstarted,
      expiry_min_notstarted: setting?.expiry_min_notstarted,
      enable_ppv_rent_live: setting?.enable_ppv_rent_live,
      enable_ppv_rent_series: setting?.enable_ppv_rent_series,
      enable_ppv_rent_audio: setting?.enable_ppv_rent_audio,
      google_analytics_link: setting?.google_analytics_link,

      //registration settings
      enable_landing_page: setting?.enable_landing_page,
      free_registration: free_registration,
      activation_email: setting?.activation_email,
      premium_upgrade: setting?.premium_upgrade,
      access_free: setting?.access_free,

      //search settings
      search_title_status: search_title_status,
      search_category_status: search_category_status,
      search_tags_status: search_tags_status,
      search_description_status: search_description_status,
      search_details_status: search_details_status,

      //serires settings
      series_season: setting?.series_season,
      series_networks_status: series_networks_status,

      //site settings
      website_name: setting?.website_name,
      website_description: setting?.website_description,
      logo: setting?.logo,
      logo_height: setting?.logo_height,
      logo_width: setting?.logo_width,
      favicon: setting?.favicon,

      //social network settings
      facebook_page_id: setting?.facebook_page_id,
      google_page_id: setting?.google_page_id,
      twitter_page_id: setting?.twitter_page_id,
      instagram_page_id: setting?.instagram_page_id,
      linkedin_page_id: setting?.linkedin_page_id,
      whatsapp_page_id: setting?.whatsapp_page_id,
      skype_page_id: setting?.skype_page_id,
      youtube_page_id: setting?.youtube_page_id,
      tiktok_page_id: setting?.tiktok_page_id,
      email_page_id: setting?.email_page_id,

      //default_time_zone
      default_time_zone: setting?.default_time_zone,

      // video settings 
      videos_per_page: videos_per_page,
      posts_per_page: setting?.posts_per_page,
      show_description: show_description,
      show_Links_and_details: show_Links_and_details,
      show_genre: show_genre,
      show_languages: show_languages,
      show_subtitle: show_subtitle,
      show_artist: show_artist,
      show_recommended_videos: show_recommended_videos,
      show_views: show_views,
      videos_expiry_status: videos_expiry_status,
      epg_status: epg_status,
      homepage_views_all_button_status: homepage_views_all_button_status,

      enable_ppv_rent: enable_ppv_rent,

      earn_amount: setting?.earn_amount ? parseInt(setting?.earn_amount, 10) : 0,
      video_clip_enable: setting?.video_clip_enable ? parseInt(setting?.video_clip_enable, 10) : 0,
      filter_status: setting?.filter_status || "", // New filter status field
      registered_device_restriction: setting?.registered_device_restriction || "",
      nonsubscribers_resolutions: setting?.nonsubscribers_resolutions || "",
      new_release_enable: Number.isNaN(parseInt(setting?.new_release_enable, 10)) ? 0 : parseInt(setting?.new_release_enable, 10),
      new_release_days: Number.isNaN(parseInt(setting?.new_release_days, 10)) ? 7 : parseInt(setting?.new_release_days, 10),

    };
    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await fetchRequest({ method: 'POST', url: `${process.env.REACT_APP_Baseurl}/admin/setting/store`, data: editInputvalue })
     
      if (response?.status) {
        toast.success(response?.message)
      }
    } catch (error) {
      toast.error( error?.response?.message ||error?.message)
      console.error("Error:", error);
    } finally {
      setProcessing(false);
      setShowOverlay(false);
    }

  }
  return (
    <>
      <AdminBackNavigation path="/settings" text="Back" />
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading="Content Settings" saveText="Update" saveMethod={handleUpdate} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Page Configuration" />

            <MessageLabel text="Content Per Page" className="mandatorySimple" />
            <small className="theme-text-color opacity-75 admin-input-description d-block mb-2">
              Default number of content to show per page
            </small>
            <AdminCustomInput
              type="number"
              min={1}
              id="videos_per_page"
              placeHolder="Enter content per page"
              name="videos_per_page"
              value={setting?.videos_per_page}
              onChange={handleInput}
              ref={videos_per_pageInputRef}
              error={validationMessagevideos_per_page}
              restrictNumberInput
            />

            <MessageLabel text="Filter Status Options" className="mandatorySimple" />
            <small className="theme-text-color opacity-75 admin-input-description d-block mb-2">
              Select which filter options should be available (Artist, Language, Genre, etc.)
            </small>
            <Select
              id="video-filter-status"
              options={filterStatusOptions}
              isMulti
              name="filter_status"
              onChange={handleFilterStatusChange}
              value={getFilterStatusValue()}
              className="custom-select-multi custom-placeholder theme-text-color mb-3"
              placeholder="Select filter options..."
            />

            <MessageLabel text={"Registered user device restriction limit"} />
            <AdminCustomInput type="number" min={0} id="registered_device_restriction" placeHolder={"Enter device restriction limit"} name="registered_device_restriction" value={setting?.registered_device_restriction} onChange={handleInput} />

            <MessageLabel text="Non subscribers resoultion" className="mandatorySimple" />
            <small className="theme-text-color opacity-75 admin-input-description d-block mb-2">
              Select resolution for non subscribers (Registered and Guest Users)
            </small>
            <Select
              id="nonsubscribers-resolutions"
              options={registrationResolutions}
              isMulti
              name="nonsubscribers_resolutions"
              onChange={handleregistrationResolutionsChange}
              value={resolvedValues}
              className="custom-select-multi custom-placeholder theme-text-color mb-3"
              placeholder="Select Resolution..."
            />

          </Wrapper>

        </LeftWrapper>

        <RightWrapper>
          <Wrapper>
            <MessageHeading text="Display Settings" />

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="Show Description" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="show_description"
                  checked={setting?.show_description == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="Show Links & Details" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="show_Links_and_details"
                  checked={setting?.show_Links_and_details == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="Enable Show Genre" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="show_genre"
                  checked={setting?.show_genre == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="Show Languages" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="show_languages"
                  checked={setting?.show_languages == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="Enable Show Subtitle" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="show_subtitle"
                  checked={setting?.show_subtitle == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="Show Artist" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="show_artist"
                  checked={setting?.show_artist == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="Show Recommended Videos" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="show_recommended_videos"
                  checked={setting?.show_recommended_videos == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="Show Views" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="show_views"
                  checked={setting?.show_views == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="Admin Video Expiry" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="videos_expiry_status"
                  checked={setting?.videos_expiry_status == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="EPG Status" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="epg_status"
                  checked={setting?.epg_status == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="Enable Home Page Views All" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="homepage_views_all_button_status"
                  checked={setting?.homepage_views_all_button_status == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            <FormContainer className="justify-content-between mb-2">
              <div className="col-7"><MessageLabel text="New Release Enable" /></div>
              <div className="col-5 text-end">
                <AdminSwitch
                  name="new_release_enable"
                  checked={setting?.new_release_enable == 1}
                  onChange={(e) => handleInputenable(e)}
                />
              </div>
            </FormContainer>

            {/* {setting?.new_release_enable == 1 && ( */}
              <>
                <MessageLabel text="New Release Days" />
                <small className="theme-text-color opacity-75 admin-input-description d-block mb-2">
                  Content published within this many days will show the "New Release" badge
                </small>
                <AdminCustomInput
                  type="number"
                  min={1}
                  id="new_release_days"
                  placeHolder="Enter number of days (e.g. 7)"
                  name="new_release_days"
                  value={setting?.new_release_days}
                  onChange={handleInput}
                />
              </>
            {/* )} */}
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
}

export default Video_Setting;
